import { FontIconName } from "client/Components";
import {
	AlertManager,
	useAlerts,
	useIsMounted
} from "client/Hooks";
import { useCallback, useMemo } from "react";
import { localize } from "client_legacy/ndaw/culture";
import {
	EventStatisticsModel,
	registerFollowComments,
	unregisterFollowComments
} from "client/Api/Hub/Events/eventViewer";

export function useFollowAction(
	eventId: number,
	isFollowing: boolean,
	onStatisticsChanged: (statistics: EventStatisticsModel) => void
): [icon: FontIconName, key: LocalizationKey, clickHandler: () => void] {
	const alertManager: AlertManager = useAlerts();
	const isMounted: () => boolean = useIsMounted();

	const clickHandler = useCallback(
		async (): Promise<void> => {
			try {
				const statistics: EventStatisticsModel = isFollowing
					? await unregisterFollowComments(eventId)
					: await registerFollowComments(eventId);

				if (!isMounted()) {
					return;
				}

				onStatisticsChanged(statistics);
			} catch (e) {
				console.error(e);
				alertManager.showError(localize("_GeneralErrorMessage"));
			}
		},
		[
			alertManager,
			eventId,
			isFollowing,
			isMounted,
			onStatisticsChanged
		]
	);

	const { icon, key } = useMemo(
		(): { icon: FontIconName; key: LocalizationKey; } => {
			return isFollowing
				? { icon: "check", key: "_Following" }
				: { icon: "plus", key: "_Follow" };
		},
		[isFollowing]
	);

	return [
		icon,
		key,
		clickHandler
	];
}
